import React from 'react'
import { BTitle, BText } from '@prague-digi/ui-components'
import { compose } from 'recompose'
import { connect } from 'react-redux'

import { intl, IntlInterface } from '../../hoc'
import messages from '../../i18n'
import { appActions, clientActions, modalDialogActions } from '../../redux'
import { PageControlButtons } from '../../components'

import styles from './styles.scss'
import handPcImg from '../../assets/handPc.svg'

interface Props extends IntlInterface {
  resetApplication: any
  prepareCacheAuth: any
  hideModalDialog: any
}

export const ResetOrContinue = ({
  hideModalDialog,
  prepareCacheAuth,
  resetApplication,
  translate,
}: Props) => {
  const doContinue = () => {
    hideModalDialog('RESET_CONTINUE_DIALOG')
    prepareCacheAuth()
  }

  return (
    <div>
      <img src={handPcImg} alt="" className={styles.cover} />
      <BTitle type="h3" center>
        {translate(messages.SaveAndReturn.resetContinueTitle)}
      </BTitle>
      <BText theme={styles.content}>
        {translate(messages.SaveAndReturn.resetContinueSubtitle)}
      </BText>

      <PageControlButtons
        onSubmit={doContinue}
        submitMessage={messages.SaveAndReturn.continueBtn}
        secondaryAction={resetApplication}
        secondaryMessage={messages.SaveAndReturn.resetBtn}
      />
    </div>
  )
}

export default compose(
  connect(null, {
    hideModalDialog: modalDialogActions.hideModalDialog,
    prepareCacheAuth: clientActions.prepareCacheAuth,
    resetApplication: appActions.resetApplication,
  }),
  intl
)(ResetOrContinue)
